/**
 * Fit Quiz controller — vanilla JS for Shopify Horizon theme.
 * Requires: ZipfitLinerQuiz, ZipfitFitQuizBridge, fit-quiz.css
 */
(function (global) {
  'use strict';

  var bridge = function () {
    return global.ZipfitFitQuizBridge || global.ZipfitFitQuizShopify || {};
  };
  var quizApi = function () {
    return global.ZipfitLinerQuiz || {};
  };

  var PROGRESS_SECTIONS = ['Your Shell', 'Your Foot', 'Your Skiing', 'Note'];

  var PHONE_PLACEHOLDER = 'Phone number';

  var COUNTRY_CODES = [
    { iso: 'US', dial: '+1', min: 10, max: 10, ex: PHONE_PLACEHOLDER, flag: '🇺🇸' },
    { iso: 'CA', dial: '+1', min: 10, max: 10, ex: PHONE_PLACEHOLDER, flag: '🇨🇦' },
    { iso: 'GB', dial: '+44', min: 9, max: 10, ex: PHONE_PLACEHOLDER, flag: '🇬🇧' },
    { iso: 'IE', dial: '+353', min: 7, max: 9, ex: PHONE_PLACEHOLDER, flag: '🇮🇪' },
    { iso: 'AU', dial: '+61', min: 9, max: 9, ex: PHONE_PLACEHOLDER, flag: '🇦🇺' },
    { iso: 'NZ', dial: '+64', min: 8, max: 10, ex: PHONE_PLACEHOLDER, flag: '🇳🇿' },
    { iso: 'FR', dial: '+33', min: 9, max: 9, ex: PHONE_PLACEHOLDER, flag: '🇫🇷' },
    { iso: 'DE', dial: '+49', min: 10, max: 11, ex: PHONE_PLACEHOLDER, flag: '🇩🇪' },
    { iso: 'CH', dial: '+41', min: 9, max: 9, ex: PHONE_PLACEHOLDER, flag: '🇨🇭' },
    { iso: 'AT', dial: '+43', min: 9, max: 11, ex: PHONE_PLACEHOLDER, flag: '🇦🇹' },
    { iso: 'IT', dial: '+39', min: 9, max: 11, ex: PHONE_PLACEHOLDER, flag: '🇮🇹' },
    { iso: 'ES', dial: '+34', min: 9, max: 9, ex: PHONE_PLACEHOLDER, flag: '🇪🇸' },
    { iso: 'SE', dial: '+46', min: 7, max: 10, ex: PHONE_PLACEHOLDER, flag: '🇸🇪' },
    { iso: 'NO', dial: '+47', min: 8, max: 8, ex: PHONE_PLACEHOLDER, flag: '🇳🇴' },
    { iso: 'FI', dial: '+358', min: 6, max: 10, ex: PHONE_PLACEHOLDER, flag: '🇫🇮' },
    { iso: 'JP', dial: '+81', min: 10, max: 10, ex: PHONE_PLACEHOLDER, flag: '🇯🇵' },
    { iso: 'KR', dial: '+82', min: 9, max: 10, ex: PHONE_PLACEHOLDER, flag: '🇰🇷' },
  ];

  var TZ_COUNTRY = {
    'Europe/London': 'GB', 'Europe/Dublin': 'IE', 'Europe/Paris': 'FR', 'Europe/Berlin': 'DE',
    'Europe/Zurich': 'CH', 'Europe/Vienna': 'AT', 'Europe/Rome': 'IT', 'Europe/Madrid': 'ES',
    'Europe/Stockholm': 'SE', 'Europe/Oslo': 'NO', 'Europe/Helsinki': 'FI',
    'Asia/Tokyo': 'JP', 'Asia/Seoul': 'KR', 'Pacific/Auckland': 'NZ',
    'Australia/Sydney': 'AU', 'America/Toronto': 'CA', 'America/Vancouver': 'CA',
  };

  var COUNTRY_BY_ISO = {};
  COUNTRY_CODES.forEach(function (c) { COUNTRY_BY_ISO[c.iso] = c; });

  var ANAT_EMOJI = {
    ff1: ['👣', 'sm'], ff2: ['👣', 'md'], ff3: ['👣', 'lg'], ff4: ['👣', 'xl'],
    a1: ['🦶', 'md'], a2: ['🦶', 'lg'], a3: ['🦶', 'xl'],
    ank1: ['🦶', 'md'], ank2: ['🦶', 'lg'], ank3: ['🦶', 'xl'],
    c1: ['🦵', 'md'], c2: ['🦵', 'lg'], c3: ['🦵', 'xl'],
  };

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function detectCountry() {
    try {
      var langs = (navigator.languages && navigator.languages.length) ? navigator.languages : [navigator.language || ''];
      for (var i = 0; i < langs.length; i++) {
        var m = /[-_]([A-Za-z]{2})(?:[-_]|$)/.exec(langs[i] || '');
        if (m && COUNTRY_BY_ISO[m[1].toUpperCase()]) return m[1].toUpperCase();
      }
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (tz && TZ_COUNTRY[tz]) return TZ_COUNTRY[tz];
    } catch (_) {}
    return 'US';
  }

  function readConfig(root) {
    var candidates = [
      root.querySelector('script.fit-quiz-config'),
      root.previousElementSibling && root.previousElementSibling.matches && root.previousElementSibling.matches('script.fit-quiz-config') ? root.previousElementSibling : null,
      root.nextElementSibling && root.nextElementSibling.matches && root.nextElementSibling.matches('script.fit-quiz-config') ? root.nextElementSibling : null,
      root.parentElement ? root.parentElement.querySelector('script.fit-quiz-config') : null,
    ];
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i]) {
        try { return JSON.parse(candidates[i].textContent || '{}'); } catch (_) { return {}; }
      }
    }
    return {};
  }

  function familyOf(boot) {
    var name = typeof boot === 'string' ? boot : (boot.fam || boot.m || '');
    var stripped = name
      .replace(/\bDual\s+BOA\b/gi, '').replace(/\bBOA\b/gi, '')
      .replace(/\b(LV|MV|HV)\b/gi, '').replace(/\b\d{2,3}\b/g, '')
      .replace(/\bSki\s+Boots?\b\s*\d*/gi, '').replace(/[®™''']/g, '')
      .replace(/\(\s*\)/g, '').replace(/\b([A-Z])\.([A-Z])\./gi, '$1$2')
      .replace(/\s\.\s/g, ' ').replace(/,/g, '.').replace(/\s\/\s/g, ' ')
      .replace(/(^|\s)\/+/g, ' ').replace(/\s{2,}/g, ' ').trim() || name;
    return stripped.replace(/\b([A-Za-z\d/.]+)\b/g, function (w) {
      if (/^[A-Z]{2,4}$/.test(w)) return w;
      if (/\d/.test(w)) return w;
      return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
    });
  }

  function famKey(brand, fam) {
    return brand + '::' + fam.toLowerCase().replace(/\s+/g, '');
  }

  function buildFamilies(brand, query) {
    var list = (global.BOOTS || []).slice();
    var ql = (query || '').trim().toLowerCase();
    if (brand) list = list.filter(function (b) { return b.b === brand; });
    if (ql) {
      list = list.filter(function (b) {
        return (b.b + ' ' + b.m + ' ' + familyOf(b)).toLowerCase().indexOf(ql) !== -1;
      });
    }
    var map = {};
    list.forEach(function (b) {
      var fam = familyOf(b);
      var key = famKey(b.b, fam);
      if (!map[key]) map[key] = { b: b.b, fam: fam, flexes: {}, volumes: {}, lasts: {}, walk: false };
      else {
        var score = function (s) { return s.split(/\s+/).filter(function (w) { return /^[A-Z][a-z]/.test(w); }).length; };
        if (score(fam) > score(map[key].fam)) map[key].fam = fam;
      }
      if (b.f) map[key].flexes[b.f] = 1;
      if (b.v && b.v !== 'nan') map[key].volumes[b.v] = 1;
      if (b.l) map[key].lasts[b.l] = 1;
      if (b.w) map[key].walk = true;
    });
    return Object.keys(map).map(function (k) {
      var m = map[k];
      return {
        b: m.b, fam: m.fam, walk: m.walk,
        flexes: Object.keys(m.flexes).map(Number).sort(function (a, c) { return a - c; }),
        volumes: Object.keys(m.volumes),
        lasts: Object.keys(m.lasts).map(Number).sort(function (a, c) { return a - c; }),
      };
    }).sort(function (a, b) { return a.b.localeCompare(b.b) || a.fam.localeCompare(b.fam); });
  }

  function familyOptions(brand, query) {
    if (!brand || !global.BOOTS) return [];
    var seen = {};
    var ql = (query || '').trim().toLowerCase();
    global.BOOTS.forEach(function (b) {
      if (b.b !== brand) return;
      var fam = familyOf(b);
      seen[famKey(brand, fam)] = fam;
    });
    var list = Object.keys(seen).map(function (k) { return seen[k]; });
    if (ql) list = list.filter(function (fam) { return (brand + ' ' + fam).toLowerCase().indexOf(ql) !== -1; });
    return list.sort();
  }

  function familyVariants(brand, family) {
    if (!brand || !family || !global.BOOTS) return [];
    var fk = famKey(brand, family);
    return global.BOOTS.filter(function (b) {
      return b.b === brand && famKey(b.b, familyOf(b)) === fk;
    });
  }

  function flexesForFamily(brand, family) {
    var seen = {};
    familyVariants(brand, family).forEach(function (b) { if (b.f) seen[b.f] = 1; });
    return Object.keys(seen).map(Number).sort(function (a, c) { return a - c; });
  }

  function mondoSteps(rangeStr) {
    var minSz = 22, maxSz = 32;
    if (rangeStr) {
      // Footnote markers such as "22.5-27.5*" are not part of the bounds.
      var cleaned = String(rangeStr).replace(/[^\d.\-]/g, '');
      var parts = cleaned.split('-').map(Number);
      if (!isNaN(parts[0]) && !isNaN(parts[1])) { minSz = parts[0]; maxSz = parts[1]; }
    }
    var steps = [];
    for (var s = Math.floor(minSz) + 0.5; s <= maxSz + 0.01; s += 1) steps.push(s.toFixed(1));
    return steps;
  }

  function lastNote(last) {
    if (!last) return '';
    if (last <= 98) return 'Low volume';
    if (last <= 100) return 'Medium volume';
    if (last <= 102) return 'Mid-high volume';
    return 'High volume';
  }

  function defaultLead(config) {
    var pre = config.leadPrefill || {};
    return {
      name: pre.name || '', email: pre.email || '', phone: '',
      country: detectCountry(), dialCode: (COUNTRY_BY_ISO[detectCountry()] || COUNTRY_BY_ISO.US).dial,
      contactPref: 'email', optIn: false, smsConsent: false, dataConsent: false,
    };
  }

  function mergeLead(lead) {
    var base = lead || defaultLead({});
    if (!base.country) {
      base.country = detectCountry();
      base.dialCode = (COUNTRY_BY_ISO[base.country] || COUNTRY_BY_ISO.US).dial;
    }
    return base;
  }

  function mount(root) {
    if (!root) return;
    var quiz = quizApi();
    if (!quiz.STAGES || !quiz.STAGES.length) {
      console.warn('fit-quiz: ZipfitLinerQuiz not ready');
      return;
    }
    var config = readConfig(root);
    var STAGES = quiz.STAGES;
    var recallToken = new URLSearchParams(global.location.search).get('s');
    var savedDraft = (!recallToken && bridge().loadDraft) ? bridge().loadDraft() : null;

    var state = {
      step: recallToken ? STAGES.indexOf('result') : (savedDraft && typeof savedDraft.step === 'number' ? savedDraft.step : 0),
      answers: mergeAnswers(savedDraft && savedDraft.answers, config),
      bootQuery: '', bootBrand: '', bootFamily: '', bootFlex: '',
      bootLoading: false, bootReady: !!(global.BOOTS && global.BOOTS.length),
      loadingResult: !!recallToken,
      submissionToken: recallToken || null,
      copy: null,
      copyStatus: null,
      copyTimer: null,
      submitting: false, addingToCart: false, notifying: false,
      cartError: null, submitted: false,
    };

    root.classList.add('fit-quiz__shell');
    root.setAttribute('data-fit-quiz-mounted', 'true');

    function scrollToQuizTop() {
      global.requestAnimationFrame(function () {
        var anchor = root.closest('.fit-quiz-section') || root;
        var top = anchor.getBoundingClientRect().top + global.scrollY - 12;
        global.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      });
    }

    var copyEpoch = 0;
    var submitGeneration = 0;

    if (recallToken && bridge().recallSubmission) {
      var mountedEpoch = copyEpoch;
      bridge().recallSubmission(recallToken)
        .then(function (data) {
          if (!copyResponseCurrent(mountedEpoch, recallToken)) return;
          applyCopyPayload(data);
          if (data && data.copy) delete data.copy;
          state.answers = mergeAnswers(data, config);
          state.loadingResult = false;
          render();
          scrollToQuizTop();
          if (copyPollActive()) startCopyPoll();
        })
        .catch(function () {
          if (!copyResponseCurrent(mountedEpoch, recallToken)) return;
          state.step = 0;
          state.loadingResult = false;
          render();
          scrollToQuizTop();
        });
    }

    root.addEventListener('click', onClick);
    root.addEventListener('change', onChange);
    root.addEventListener('input', onInput);

    render();

    function mergeAnswers(base, cfg) {
      var out = Object.assign({}, base || {});
      if (!out.lead) out.lead = defaultLead(cfg);
      else out.lead = mergeLead(out.lead);
      return out;
    }

    function stage() { return STAGES[state.step] || 'intro'; }

    function visibleStages() {
      return quiz.visibleQuestionStages ? quiz.visibleQuestionStages(state.answers) : [];
    }

    function canAdvance() {
      return quiz.canAdvanceStage
        ? quiz.canAdvanceStage(stage(), state.answers, COUNTRY_BY_ISO)
        : false;
    }

    function goNext() {
      flushContext();
      state.step = quiz.nextStepIndex ? quiz.nextStepIndex(state.step, state.answers) : Math.min(state.step + 1, STAGES.length - 1);
      maybeLoadBootDb();
      saveDraft();
      render();
      scrollToQuizTop();
    }

    function goBack() {
      flushContext();
      state.step = quiz.prevStepIndex ? quiz.prevStepIndex(state.step, state.answers) : Math.max(state.step - 1, 0);
      render();
      scrollToQuizTop();
    }

    function restart() {
      if (bridge().clearDraft) bridge().clearDraft();
      state.answers = { lead: defaultLead(config) };
      state.step = 0;
      state.bootQuery = state.bootBrand = state.bootFamily = state.bootFlex = '';
      resetSubmission();
      invalidateSavedCopy();
      render();
      scrollToQuizTop();
    }

    function saveDraft() {
      if (recallToken || !bridge().saveDraft) return;
      bridge().saveDraft(state.answers, state.step);
    }

    function setAnswer(key, val, options) {
      var changed = JSON.stringify(state.answers[key]) !== JSON.stringify(val);
      if (changed) invalidateSavedCopy();
      if (changed && key === 'context') resetSubmission();
      state.answers[key] = val;
      saveDraft();
      if (!options || !options.silent) render();
    }

    function resetSubmission() {
      submitGeneration += 1;
      state.submissionToken = null;
      state.submitted = false;
      state.submitting = false;
    }

    function commitContextField(field, trim) {
      if (!field) return;
      var key = field.getAttribute('data-answer');
      if (!key) return;
      var q = quiz.getQ ? quiz.getQ(key) : (global.getQ && global.getQ(key));
      var limit = q && q.max ? q.max : 1500;
      var text = String(field.value || '');
      if (text.length > limit) text = text.slice(0, limit);
      if (trim) text = text.replace(/^\s+|\s+$/g, '');
      setAnswer(key, text ? text : undefined, { silent: true });
    }

    function flushContext() {
      commitContextField(root.querySelector('textarea[data-answer]'), true);
    }

    function maybeLoadBootDb() {
      if (stage() !== 'boot' || state.bootReady || state.bootLoading) return;
      var url = config.bootDbUrl;
      var fallback = config.bootDbFallbackUrl;
      if (!url || !quiz.loadBootDatabase) return;
      state.bootLoading = true;
      render();
      quiz.loadBootDatabase(url)
        .catch(function () {
          if (fallback && fallback !== url) return quiz.loadBootDatabase(fallback);
          throw new Error('boot_db');
        })
        .then(function () { state.bootReady = true; state.bootLoading = false; render(); })
        .catch(function () { state.bootLoading = false; render(); });
    }

    if (stage() === 'boot') maybeLoadBootDb();

    function onClick(e) {
      var t = e.target.closest('[data-action]');
      if (!t || !root.contains(t)) return;
      var action = t.getAttribute('data-action');

      if (action === 'start') { state.step = 1; saveDraft(); render(); scrollToQuizTop(); return; }
      if (action === 'next') { if (canAdvance()) goNext(); return; }
      if (action === 'back') { goBack(); return; }
      if (action === 'restart') { restart(); return; }
      if (action === 'clear-boot') {
        if (state.answers.boot) invalidateSavedCopy();
        state.answers.boot = null;
        state.bootBrand = state.bootFamily = state.bootFlex = '';
        saveDraft(); render(); return;
      }
      if (action === 'boot-family') {
        state.bootBrand = t.getAttribute('data-brand') || '';
        state.bootFamily = t.getAttribute('data-family') || '';
        state.bootFlex = '';
        render(); return;
      }
      if (action === 'pick-boot') {
        var id = t.getAttribute('data-id');
        var boot = (global.BOOTS || []).find(function (b) {
          return String(b.i) === id || String(b.id) === id;
        });
        if (boot) {
          if (bootIdentity(state.answers.boot) !== bootIdentity(boot)) invalidateSavedCopy();
          state.answers.boot = boot;
          saveDraft();
          render();
        }
        return;
      }
      if (action === 'boot-flex') {
        var flex = t.getAttribute('data-flex') || '';
        state.bootFlex = state.bootFlex === flex ? '' : flex;
        render(); return;
      }
      if (action === 'lead-pref') {
        state.answers.lead = mergeLead(state.answers.lead);
        state.answers.lead.contactPref = t.getAttribute('data-value') || 'email';
        saveDraft(); render(); return;
      }
      if (action === 'sms-toggle') {
        var l = mergeLead(state.answers.lead);
        if (phoneOk(l)) { l.smsConsent = !l.smsConsent; state.answers.lead = l; saveDraft(); render(); }
        return;
      }
      if (action === 'anat' || action === 'choice') {
        var aKey = t.getAttribute('data-key');
        var aVal = t.getAttribute('data-value');
        if (aKey === 'ability') aVal = Number(aVal);
        setAnswer(aKey, aVal);
        return;
      }
      if (action === 'toggle-multi') {
        var key = t.getAttribute('data-key');
        var val = t.getAttribute('data-value');
        var cur = Array.isArray(state.answers[key]) ? state.answers[key].slice() : (state.answers[key] ? [state.answers[key]] : []);
        var idx = cur.indexOf(val);
        if (key === 'fit_problem') {
          if (val === 'none') cur = idx > -1 ? [] : ['none'];
          else { cur = cur.filter(function (v) { return v !== 'none'; }); cur = idx > -1 ? cur.filter(function (v) { return v !== val; }) : cur.concat(val); }
        } else {
          cur = idx > -1 ? cur.filter(function (v) { return v !== val; }) : cur.concat(val);
        }
        setAnswer(key, cur);
        return;
      }
      if (action === 'add-cart') { addToCart(); return; }
      if (action === 'notify-stock') { notifyStock(); return; }
    }

    function onChange(e) {
      var t = e.target;
      if (!root.contains(t)) return;
      if (t.matches('[data-field="boot-brand"]')) {
        state.bootBrand = t.value; state.bootFamily = state.bootFlex = ''; render(); return;
      }
      if (t.matches('[data-field="boot-family"]')) {
        state.bootFamily = t.value; state.bootFlex = ''; render(); return;
      }
      if (t.matches('[data-field="boot-size"]')) {
        if (state.answers.boot) {
          if (scalarAnswer(state.answers.boot.sz) !== scalarAnswer(t.value)) invalidateSavedCopy();
          state.answers.boot = Object.assign({}, state.answers.boot, { sz: t.value || null });
          saveDraft();
        }
        return;
      }
      if (t.matches('[data-field="lead-country"]')) {
        var c = COUNTRY_BY_ISO[t.value] || COUNTRY_BY_ISO.US;
        state.answers.lead = mergeLead(state.answers.lead);
        state.answers.lead.country = c.iso;
        state.answers.lead.dialCode = c.dial;
        saveDraft(); render(); return;
      }
      if (t.matches('[data-lead]')) {
        state.answers.lead = mergeLead(state.answers.lead);
        var field = t.getAttribute('data-lead');
        if (field === 'dataConsent' || field === 'optIn') state.answers.lead[field] = t.checked;
        else state.answers.lead[field] = t.value;
        if (field === 'phone' && !t.value) state.answers.lead.smsConsent = false;
        saveDraft(); render();
      }
      if (t.matches('textarea[data-answer]')) {
        commitContextField(t, false);
        return;
      }
      if (t.matches('[data-answer]')) {
        var key = t.getAttribute('data-answer');
        var raw = t.value;
        setAnswer(key, raw === '' ? undefined : (t.type === 'number' ? parseFloat(raw) : raw));
      }
    }

    function onInput(e) {
      var t = e.target;
      if (t.matches('textarea[data-answer]')) {
        commitContextField(t, false);
        return;
      }
      if (t.matches('[data-field="boot-search"]')) {
        state.bootQuery = t.value;
        renderPreserveFocus('boot-search');
      }
    }

    function renderPreserveFocus(field) {
      var el = root.querySelector('[data-field="' + field + '"]');
      var start = el ? el.selectionStart : null;
      var end = el ? el.selectionEnd : null;
      render();
      var next = root.querySelector('[data-field="' + field + '"]');
      if (next) {
        next.focus();
        if (start != null) try { next.setSelectionRange(start, end); } catch (_) {}
      }
    }

    function phoneOk(l) {
      var c = COUNTRY_BY_ISO[(l && l.country) || 'US'] || COUNTRY_BY_ISO.US;
      var n = ((l && l.phone) || '').replace(/\D/g, '').length;
      return n >= c.min && n <= c.max;
    }

    function trimmedContext(value) {
      return String(value == null ? '' : value).replace(/^\s+|\s+$/g, '');
    }

    function submitResultIfNeeded(top) {
      if (state.submitted || state.submissionToken || !bridge().submitSubmission || !top) return;
      var lead = state.answers.lead || {};
      var contactId = lead.email || lead.phone;
      if (!contactId) return;
      var note = trimmedContext(state.answers.context);
      var sigKey = '__zf_' + contactId + ':' + top.id + ':' + note;
      try {
        var prior = sessionStorage.getItem(sigKey);
        if (prior) {
          state.submissionToken = prior;
          state.submitted = true;
          recallSavedCopy(prior);
          return;
        }
      } catch (_) {}
      var generation = submitGeneration;
      state.submitting = true;
      state.submitted = true;
      var submitEpoch = copyEpoch;
      bridge().submitSubmission({
        lead: lead,
        boot: state.answers.boot || null,
        match: { id: top.id, name: top.name },
        answers: {
          ff: state.answers.ff, ins: state.answers.ins, ank: state.answers.ank, cal: state.answers.cal,
          fit_problem: state.answers.fit_problem, ability: state.answers.ability,
          terrain: state.answers.terrain, touring_primary: state.answers.touring_primary,
          foot_len: state.answers.foot_len,
          context: note || undefined,
        },
        submittedAt: new Date().toISOString(),
      }).then(function (res) {
        if (!res || !res.token) return;
        try { sessionStorage.setItem(sigKey, res.token); } catch (_) {}
        if (generation !== submitGeneration || trimmedContext(state.answers.context) !== note) return;
        state.submissionToken = res.token;
        state.submitted = true;
        if (submitEpoch === copyEpoch && res.copy_status) state.copyStatus = res.copy_status;
      }).catch(function (err) { console.warn('fit-quiz submit failed', err); })
        .finally(function () {
          if (generation !== submitGeneration) return;
          state.submitting = false;
          render();
          if (submitEpoch === copyEpoch && copyPollActive()) startCopyPoll();
        });
    }

    function computeMatch(answers) {
      return quiz.computeMatch ? quiz.computeMatch(answers) : null;
    }

    function addToCart() {
      var match = computeMatch(state.answers);
      var top = match && match.primary;
      if (!top || !bridge().addRecommendedToCart) return;
      var linerSize = sizing().linerSize;
      state.addingToCart = true; state.cartError = null; render();
      bridge().addRecommendedToCart(top.id, linerSize, state.submissionToken)
        .catch(function (e) { state.cartError = e.message || 'Could not add to cart.'; })
        .finally(function () { state.addingToCart = false; render(); });
    }

    function notifyStock() {
      var match = computeMatch(state.answers);
      var top = match && match.primary;
      if (!top || !bridge().openBackInStockNotify) return;
      state.notifying = true; state.cartError = null; render();
      bridge().openBackInStockNotify(top.id, sizing().linerSize, { email: state.answers.lead && state.answers.lead.email })
        .catch(function (e) { state.cartError = e.message || 'Could not open notify form.'; })
        .finally(function () { state.notifying = false; render(); });
    }

    function sizing() {
      var footCm = state.answers.foot_len !== undefined ? parseFloat(state.answers.foot_len) : NaN;
      var footMondo = !isNaN(footCm) ? Math.round(footCm * 2) / 2 : null;
      var shellSz = state.answers.boot && state.answers.boot.sz ? parseFloat(state.answers.boot.sz) : null;
      return { footMondo: footMondo, shellSz: shellSz, linerSize: shellSz != null ? shellSz : footMondo };
    }

    function renderProgress(q, stepNum, totalQs) {
      var sec = q ? q.sec : '';
      var pct = totalQs ? Math.round((stepNum / totalQs) * 100) : 0;
      var html = '<div class="fit-quiz__progress"><div class="fit-quiz__progress-sections">';
      PROGRESS_SECTIONS.forEach(function (s, i) {
        var active = s === sec;
        var done = PROGRESS_SECTIONS.indexOf(sec) > i;
        html += '<div class="fit-quiz__progress-section"><span class="fit-quiz__progress-section-label' +
          (active ? ' fit-quiz__progress-section-label--active' : done ? ' fit-quiz__progress-section-label--done' : '') + '">' + esc(s) +
          '</span><div class="fit-quiz__progress-section-bar' + (active || done ? ' fit-quiz__progress-section-bar--active fit-quiz__progress-section-bar--done' : '') + '"></div></div>';
      });
      html += '</div><div class="fit-quiz__progress-meta"><span>Step ' + stepNum +
        ' <span class="fit-quiz__progress-meta-muted">/ ' + totalQs + '</span></span><span>' + pct + '% complete</span></div></div>';
      return html;
    }

    function renderIntro() {
      var img = config.assets && config.assets.lifestyleLiner;
      return '<div class="fit-quiz__intro"><p class="fit-quiz__eyebrow">Custom liners · Made in Italy · Since 1989</p>' +
        '<h1 class="h1">Find your fit.</h1><p class="paragraph fit-quiz__hint">Six questions about your shell, foot shape, and how you ski. We match you to one of seven ZipFits — handmade in Italy.</p>' +
        (img ? '<div class="fit-quiz__intro-card"><img src="' + esc(img) + '" alt="" loading="lazy"><p class="paragraph">Have a soft tape measure handy — we\'ll ask about your ankle and calf circumference.</p></div>' : '') +
        '<div class="fit-quiz__intro-actions"><button type="button" class="button" data-action="start">Begin →</button><span class="fit-quiz__intro-meta">~ 2 minutes · 8 steps</span></div></div>';
    }

    function renderLead() {
      var l = mergeLead(state.answers.lead);
      var cc = COUNTRY_BY_ISO[l.country] || COUNTRY_BY_ISO.US;
      var pref = l.contactPref === 'text' ? 'text' : 'email';
      var emailOk = l.email && /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(l.email.trim());
      var phoneValid = !l.phone || phoneOk(l);
      return '<div class="fit-quiz__lead"><p class="fit-quiz__eyebrow">Let\'s get started</p><h2 class="h2">First, who are we fitting?</h2>' +
        '<p class="paragraph fit-quiz__hint">We\'ll send your match so you can refer back to it anytime — and so a ZipFit bootfitter can follow up if you want help dialing in the fit.</p>' +
        '<div class="fit-quiz__form">' +
        '<div class="fit-quiz__field"><span class="fit-quiz__field-label">How should we send your results?</span>' +
        '<div class="fit-quiz__pref-toggle">' +
        '<button type="button" class="fit-quiz__pref-btn' + (pref === 'email' ? ' fit-quiz__pref-btn--active' : '') + '" data-action="lead-pref" data-value="email">Email</button>' +
        '<button type="button" class="fit-quiz__pref-btn' + (pref === 'text' ? ' fit-quiz__pref-btn--active' : '') + '" data-action="lead-pref" data-value="text">Text</button></div></div>' +
        fieldInput('First name', 'name', l.name, 'Your first name', true, false) +
        fieldInput('Email', 'email', l.email, 'your@email.com', true, !emailOk && l.email) +
        (!emailOk && l.email ? '<span class="fit-quiz__field-error">That doesn\'t look like a valid email.</span>' : '') +
        '<label class="fit-quiz__field"><span class="fit-quiz__field-label">Phone<em>' + (pref === 'text' ? ' required' : ' optional') + '</em></span>' +
        '<div class="fit-quiz__input-row"><select class="fit-quiz__select" data-field="lead-country" data-lead="country">' +
        COUNTRY_CODES.map(function (c) { return '<option value="' + c.iso + '"' + (c.iso === cc.iso ? ' selected' : '') + '>' + c.flag + ' ' + c.iso + ' ' + c.dial + '</option>'; }).join('') +
        '</select><input class="fit-quiz__input' + ((!phoneValid && l.phone) || (pref === 'text' && !l.phone) ? ' fit-quiz__input--error' : '') + '" type="tel" data-lead="phone" value="' + esc(l.phone || '') + '" placeholder="' + esc(cc.ex) + '"></div>' +
        (!phoneValid && l.phone ? '<span class="fit-quiz__field-error">That doesn\'t look like a valid phone number.</span>' : '') + '</label>' +
        checkboxLead('dataConsent', l.dataConsent, 'I agree to let ZipFit store my boot, foot-measurement, and contact details to generate my fit recommendation and email it to me, as described in the <a href="https://zipfit.com/policies/privacy-policy" target="_blank" rel="noopener noreferrer">privacy policy</a>. <em>required</em>') +
        checkboxLead('optIn', l.optIn, 'Email me fit tips, product news, and the occasional update. Unsubscribe anytime.') +
        smsCard(l) +
        '<p class="fit-quiz__legal">See our <a href="https://zipfit.com/policies/privacy-policy" target="_blank" rel="noopener noreferrer">privacy policy</a> and <a href="https://zipfit.com/policies/terms-of-service" target="_blank" rel="noopener noreferrer">terms</a>.</p></div></div>';
    }

    function fieldInput(label, field, val, ph, req, err) {
      return '<label class="fit-quiz__field"><span class="fit-quiz__field-label">' + esc(label) + '<em>' + (req ? ' required' : ' optional') + '</em></span>' +
        '<input class="fit-quiz__input' + (err ? ' fit-quiz__input--error' : '') + '" type="' + (field === 'email' ? 'email' : 'text') + '" data-lead="' + field + '" value="' + esc(val || '') + '" placeholder="' + esc(ph) + '"></label>';
    }

    function checkboxLead(field, checked, html) {
      return '<label class="fit-quiz__checkbox"><input type="checkbox" data-lead="' + field + '"' + (checked ? ' checked' : '') + '><span>' + html + '</span></label>';
    }

    function smsCard(l) {
      var ready = phoneOk(l);
      return '<div class="fit-quiz__sms-card' + (l.smsConsent ? ' fit-quiz__sms-card--active' : '') + (!ready ? ' fit-quiz__sms-card--disabled' : '') + '">' +
        '<div class="fit-quiz__sms-head"><span>📱 Text me fit tips &amp; updates</span>' +
        '<button type="button" class="fit-quiz__sms-toggle' + (l.smsConsent ? ' fit-quiz__sms-toggle--active' : '') + '" data-action="sms-toggle"' + (!ready ? ' disabled' : '') + '>' +
        (l.smsConsent ? '✓ Subscribed' : 'Subscribe') + '</button></div>' +
        '<p class="fit-quiz__legal">By opting in I consent to receive recurring automated marketing text messages from ZipFit. Reply STOP to cancel.</p></div>';
    }

    function renderBootPicker() {
      if (state.bootLoading) return '<div class="fit-quiz__loading paragraph">Loading boot database…</div>';
      var boot = state.answers.boot;
      if (boot) return renderBootConfirmed(boot);
      var families = buildFamilies(state.bootBrand, state.bootQuery);
      var narrowed = !!(state.bootBrand || state.bootQuery.trim());
      var flexes = state.bootFamily ? flexesForFamily(state.bootBrand, state.bootFamily) : [];
      var fopts = familyOptions(state.bootBrand, state.bootQuery);
      var html = '<div class="fit-quiz__boot"><div class="fit-quiz__boot-search-wrap">' +
        '<svg class="fit-quiz__boot-search-icon" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><circle cx="7" cy="7" r="5" stroke="currentColor" stroke-width="1.5" fill="none"/><path d="M11 11l3.5 3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
        '<input class="fit-quiz__input fit-quiz__boot-search" data-field="boot-search" value="' + esc(state.bootQuery) + '" placeholder="' +
        esc(state.bootBrand ? 'Search ' + state.bootBrand + ' models…' : 'Search by brand or model…') + '"></div>' +
        '<div class="fit-quiz__boot-filters"><label class="fit-quiz__field"><span class="fit-quiz__field-label">Brand</span>' +
        '<select class="fit-quiz__select" data-field="boot-brand"><option value="">Any brand</option>' +
        (global.BRANDS || []).map(function (b) { return '<option value="' + esc(b) + '"' + (b === state.bootBrand ? ' selected' : '') + '>' + esc(b) + '</option>'; }).join('') +
        '</select></label><label class="fit-quiz__field"><span class="fit-quiz__field-label">Model</span>' +
        '<select class="fit-quiz__select" data-field="boot-family"' + (!state.bootBrand ? ' disabled' : '') + '><option value="">' + (state.bootBrand ? 'Any model' : '—') + '</option>' +
        fopts.map(function (m) { return '<option value="' + esc(m) + '"' + (m === state.bootFamily ? ' selected' : '') + '>' + esc(m) + '</option>'; }).join('') +
        '</select></label></div>';
      if (state.bootFamily && flexes.length > 1) {
        html += '<div class="fit-quiz__boot-flex-panel"><p class="fit-quiz__eyebrow">Pick a flex for ' + esc(state.bootFamily) + '</p><div class="fit-quiz__boot-flex-chips">' +
          flexes.map(function (f) {
            var active = String(state.bootFlex) === String(f);
            return '<button type="button" class="fit-quiz__chip' + (active ? ' fit-quiz__chip--active' : '') + '" data-action="boot-flex" data-flex="' + f + '">' + f + '</button>';
          }).join('') + '</div></div>';
      }
      html += '<div class="fit-quiz__boot-list">' + renderBootList(families, narrowed, flexes) + '</div></div>';
      return html;
    }

    function renderBootList(families, narrowed, flexes) {
      if (!narrowed) {
        return '<div class="fit-quiz__boot-empty"><p class="fit-quiz__eyebrow">' + families.length + ' model families in our database</p><p class="paragraph">Pick a brand above or search to see matching shells.</p></div>';
      }
      if (state.bootFamily) {
        var variants = familyVariants(state.bootBrand, state.bootFamily)
          .filter(function (b) { return !state.bootFlex || String(b.f) === String(state.bootFlex); })
          .sort(function (a, b) { return (a.f || 0) - (b.f || 0) || String(b.y).localeCompare(String(a.y)); });
        if (!variants.length) return '<div class="fit-quiz__boot-empty paragraph">No variants for ' + esc(state.bootFamily) + (state.bootFlex ? ' at flex ' + state.bootFlex : '') + '.</div>';
        return '<div class="fit-quiz__boot-list-head"><span>' + esc(state.bootBrand) + ' · ' + esc(state.bootFamily) +
          (state.bootFlex ? ' · Flex ' + state.bootFlex : '') + ' · ' + variants.length + ' variant' + (variants.length === 1 ? '' : 's') + '</span>' +
          '<span class="fit-quiz__boot-list-head-muted">flex · last · year</span></div>' +
          variants.map(function (b) { return bootVariantRow(b); }).join('');
      }
      if (!families.length) return '<div class="fit-quiz__boot-empty paragraph">No shells match. Try a different brand or clear the search.</div>';
      return '<div class="fit-quiz__boot-list-head"><span>' + families.length + ' model' + (families.length === 1 ? '' : 's') + '</span><span class="fit-quiz__boot-list-head-muted">last · volume · flex options</span></div>' +
        families.map(function (f) {
          var active = state.bootBrand === f.b && state.bootFamily === f.fam;
          return '<button type="button" class="fit-quiz__boot-row' + (active ? ' fit-quiz__boot-row--active' : '') + '" data-action="boot-family" data-brand="' + esc(f.b) + '" data-family="' + esc(f.fam) + '">' +
            '<span class="fit-quiz__boot-rail"></span><span class="fit-quiz__boot-row-main"><span class="fit-quiz__boot-row-title">' + esc(f.fam) + '</span>' +
            '<span class="fit-quiz__boot-row-sub">' + esc(f.b) + (f.walk ? ' · Walk' : '') + '</span></span><span class="fit-quiz__boot-tags">' +
            (f.lasts.length ? tag(f.lasts.length === 1 ? f.lasts[0] + 'mm' : f.lasts[0] + '–' + f.lasts[f.lasts.length - 1]) : '') +
            (f.volumes.length ? tag(f.volumes.join('/')) : '') +
            (f.flexes.length ? tag(f.flexes.length === 1 ? 'Flex ' + f.flexes[0] : f.flexes[0] + '–' + f.flexes[f.flexes.length - 1]) : '') +
            '</span></button>';
        }).join('');
    }

    function bootVariantRow(b) {
      return '<button type="button" class="fit-quiz__boot-row" data-action="pick-boot" data-id="' + b.i + '"><span class="fit-quiz__boot-rail"></span>' +
        '<span class="fit-quiz__boot-row-main"><span class="fit-quiz__boot-row-title">' + esc(b.m) + '</span><span class="fit-quiz__boot-row-sub">' +
        esc(b.y) + (b.g === 'W' ? ' · Women' : '') + (b.w ? ' · Walk' : '') + (b.c ? ' · ' + b.c : '') + '</span></span><span class="fit-quiz__boot-tags">' +
        (b.f ? tag(String(b.f)) : '') + (b.l ? tag(b.l + 'mm') : '') + (b.v && b.v !== 'nan' ? tag(b.v) : '') + '</span></button>';
    }

    function tag(text) { return '<span class="fit-quiz__tag">' + esc(text) + '</span>'; }

    function renderBootConfirmed(boot) {
      var last = boot.l || 0;
      var steps = mondoSteps(boot.szr);
      return '<div class="fit-quiz__boot-confirmed"><div class="fit-quiz__boot-confirmed-bar"></div><div class="fit-quiz__boot-confirmed-head">' +
        '<div><p class="fit-quiz__eyebrow">✓ Shell confirmed</p><h3 class="h3 fit-quiz__boot-confirmed-title">' + esc(boot.m) + '</h3>' +
        '<p class="fit-quiz__boot-confirmed-meta">' + esc(boot.b) + ' · ' + esc(boot.y) + (boot.w ? ' · Walk mode' : '') + '</p></div>' +
        '<button type="button" class="button-secondary fit-quiz__nav-ghost" data-action="clear-boot">Change</button></div>' +
        '<div class="fit-quiz__boot-dna">' +
        dnaCell('Last', boot.l ? boot.l + 'mm' : '—', lastNote(last)) +
        dnaCell('Volume', boot.v && boot.v !== 'nan' ? boot.v : '—', '') +
        dnaCell('Flex', boot.f || '—', '') + '</div>' +
        '<div class="fit-quiz__boot-size"><p class="fit-quiz__eyebrow">Your shell\'s mondo size (optional)</p>' +
        '<select class="fit-quiz__select" data-field="boot-size"><option value="">' + (boot.szr ? 'Sizes ' + esc(boot.szr) + ' — select yours' : 'Select size…') + '</option>' +
        steps.map(function (s) { return '<option value="' + s + '"' + (boot.sz === s ? ' selected' : '') + '>' + s + '</option>'; }).join('') +
        '</select></div></div>';
    }

    function dnaCell(label, value, note) {
      return '<div class="fit-quiz__boot-dna-cell"><div class="fit-quiz__boot-dna-label">' + esc(label) + '</div>' +
        '<div class="fit-quiz__boot-dna-value">' + esc(value) + '</div>' + (note ? '<div class="fit-quiz__boot-dna-note">' + esc(note) + '</div>' : '') + '</div>';
    }

    function renderQuestion(q) {
      if (q.type === 'boot') return renderBootPicker();
      if (q.type === 'number') return renderNumber(q);
      if (q.type === 'anat') return renderAnat(q);
      if (q.type === 'choice') return renderChoice(q);
      if (q.type === 'text') return renderText(q);
      return '';
    }

    function renderText(q) {
      var val = state.answers[q.id];
      var max = q.max || 1500;
      return '<textarea class="fit-quiz__input fit-quiz__textarea" data-answer="' + esc(q.id) + '" maxlength="' + max + '" rows="6" aria-label="' + esc(q.txt) + '" placeholder="' + esc(q.placeholder || '') + '">' + esc(val == null ? '' : val) + '</textarea>';
    }

    function renderNumber(q) {
      var val = state.answers[q.id];
      var rounded = val !== undefined && !isNaN(parseFloat(val)) ? (Math.round(parseFloat(val) * 2) / 2).toFixed(1) : null;
      return '<div class="fit-quiz__number-row"><input class="fit-quiz__input fit-quiz__number-input" type="number" min="' + q.min + '" max="' + q.max + '" step="0.5" data-answer="' + q.id + '" value="' +
        (val !== undefined ? esc(val) : '') + '" placeholder="e.g. 26.5"><span class="fit-quiz__number-unit">cm</span></div>' +
        (rounded ? '<p class="fit-quiz__number-note paragraph">Your foot measures mondo <strong>' + rounded + '</strong></p>' : '');
    }

    function anatGridClass(q) {
      var cols = q.cols === 'f4' ? 4 : 3;
      if (global.innerWidth < 600) cols = 2;
      return 'fit-quiz__anat-grid fit-quiz__anat-grid--' + cols;
    }

    function renderAnat(q) {
      return '<div class="' + anatGridClass(q) + '">' + q.opts.map(function (o) {
        var active = state.answers[q.id] === o.v;
        var em = ANAT_EMOJI[o.s] || ['🦶', 'md'];
        return '<button type="button" class="fit-quiz__anat-card' + (active ? ' fit-quiz__anat-card--active' : '') + '" data-action="anat" data-key="' + q.id + '" data-value="' + esc(o.v) + '">' +
          '<span class="fit-quiz__anat-emoji"><span class="fit-quiz__emoji fit-quiz__emoji--' + em[1] + '">' + em[0] + '</span></span>' +
          '<span class="fit-quiz__anat-label">' + esc(o.l) + '</span><span class="fit-quiz__anat-desc">' + esc(o.d) + '</span></button>';
      }).join('') + '</div>';
    }

    function renderChoice(q) {
      var multi = q.id === 'fit_problem' || q.id === 'terrain' || q.multi;
      var cur = state.answers[q.id];
      var terrainImages = (config.terrainImages && q.id === 'terrain') ? config.terrainImages : null;
      var html = multi ? '<p class="fit-quiz__multi-hint">Select all that apply</p>' : '';
      html += '<div class="fit-quiz__choices">' + q.opts.map(function (o) {
        var active = multi
          ? (Array.isArray(cur) ? cur.indexOf(o.v) > -1 : cur === o.v)
          : (q.id === 'ability' ? Number(cur) === Number(o.v) : cur === o.v);
        var icon = '';
        if (terrainImages && terrainImages[o.v]) {
          icon = '<span class="fit-quiz__choice-icon fit-quiz__choice-icon--photo"><img src="' + esc(terrainImages[o.v]) + '" alt="" loading="lazy"></span>';
        } else if (o.ic) {
          icon = '<span class="fit-quiz__choice-icon">' + o.ic + '</span>';
        }
        return '<button type="button" class="fit-quiz__choice' + (active ? ' fit-quiz__choice--active' : '') + '" data-action="' + (multi ? 'toggle-multi' : 'choice') + '" data-key="' + q.id + '" data-value="' + esc(String(o.v)) + '">' +
          icon +
          '<span class="fit-quiz__choice-text"><span class="fit-quiz__choice-label">' + esc(o.l) + '</span>' +
          (o.d ? '<span class="fit-quiz__choice-desc">' + esc(o.d) + '</span>' : '') + '</span></button>';
      }).join('') + '</div>';
      return html;
    }

    var copyAttempts = 0;
    var copyStartedAt = 0;
    var copyDeadlineTimer = null;
    var COPY_POLL_MS = 2000;
    var COPY_POLL_MAX = 30;
    var COPY_POLL_DEADLINE_MS = 60000;

    function copyResponseCurrent(epoch, token) {
      return epoch === copyEpoch && token === state.submissionToken;
    }

    function invalidateSavedCopy() {
      copyEpoch += 1;
      state.copy = null;
      state.copyStatus = null;
      stopCopyPoll();
      clearCopyDeadline();
    }

    function scalarAnswer(value) {
      if (value == null || value === '') return '';
      return String(value);
    }

    function answerList(value) {
      var list = Array.isArray(value) ? value : (value == null || value === '' ? [] : [value]);
      return list.map(function (item) { return String(item); }).sort();
    }

    function sameAnswerList(left, right) {
      var a = answerList(left);
      var b = answerList(right);
      if (a.length !== b.length) return false;
      for (var i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
      return true;
    }

    function bootIdentity(boot) {
      if (!boot) return '';
      return [boot.i || boot.id || '', boot.sz || ''].join('|');
    }

    function savedAnswersMatch(data) {
      var current = state.answers || {};
      var saved = data || {};
      if (scalarAnswer(current.ff) !== scalarAnswer(saved.ff)) return false;
      if (scalarAnswer(current.ins) !== scalarAnswer(saved.ins)) return false;
      if (scalarAnswer(current.ank) !== scalarAnswer(saved.ank)) return false;
      if (scalarAnswer(current.cal) !== scalarAnswer(saved.cal)) return false;
      if (scalarAnswer(current.ability) !== scalarAnswer(saved.ability)) return false;
      if (scalarAnswer(current.touring_primary) !== scalarAnswer(saved.touring_primary)) return false;
      if (scalarAnswer(current.foot_len) !== scalarAnswer(saved.foot_len)) return false;
      if (scalarAnswer(current.context) !== scalarAnswer(saved.context)) return false;
      if (!sameAnswerList(current.fit_problem, saved.fit_problem)) return false;
      if (!sameAnswerList(current.terrain, saved.terrain)) return false;
      return bootIdentity(current.boot) === bootIdentity(saved.boot);
    }

    function recallSavedCopy(token) {
      if (!token || !bridge().recallSubmission) return;
      var epoch = copyEpoch;
      bridge().recallSubmission(token).then(function (data) {
        if (!copyResponseCurrent(epoch, token)) return;
        if (!savedAnswersMatch(data)) return;
        if (applyCopyPayload(data)) render();
        if (copyPollActive()) startCopyPoll();
      }).catch(function () {});
    }

    function copyFingerprint() {
      var paragraph = state.copy && state.copy.paragraph ? state.copy.paragraph : '';
      return (state.copyStatus || '') + '|' + paragraph.length;
    }

    function applyCopyPayload(data) {
      var copy = data && data.copy;
      if (!copy || !copy.status) return false;
      var before = copyFingerprint();
      state.copyStatus = copy.status;
      if (copy.status === 'ready' && copy.paragraph) {
        state.copy = { paragraph: copy.paragraph };
      } else if (copy.status !== 'pending' && copy.status !== 'generating') {
        state.copy = null;
      }
      return copyFingerprint() !== before;
    }

    function copyPollActive() {
      return state.copyStatus === 'pending' || state.copyStatus === 'generating';
    }

    function stopCopyPoll() {
      if (state.copyTimer) {
        clearTimeout(state.copyTimer);
        state.copyTimer = null;
      }
    }

    function clearCopyDeadline() {
      if (copyDeadlineTimer) {
        clearTimeout(copyDeadlineTimer);
        copyDeadlineTimer = null;
      }
    }

    function copyWaitExpired() {
      return copyStartedAt > 0 && (Date.now() - copyStartedAt) >= COPY_POLL_DEADLINE_MS;
    }

    function failCopyWait() {
      copyEpoch += 1;
      stopCopyPoll();
      clearCopyDeadline();
      state.copy = null;
      state.copyStatus = 'failed';
      render();
    }

    function scheduleCopyPoll() {
      if (!copyPollActive()) return;
      if (copyAttempts >= COPY_POLL_MAX || copyWaitExpired()) {
        failCopyWait();
        return;
      }
      stopCopyPoll();
      var remaining = COPY_POLL_DEADLINE_MS - (Date.now() - copyStartedAt);
      state.copyTimer = setTimeout(pollCopyOnce, Math.min(COPY_POLL_MS, Math.max(0, remaining)));
    }

    function pollCopyOnce() {
      if (!state.submissionToken || !bridge().recallSubmission) return;
      if (copyWaitExpired()) {
        failCopyWait();
        return;
      }
      var epoch = copyEpoch;
      var token = state.submissionToken;
      copyAttempts += 1;
      bridge().recallSubmission(token).then(function (data) {
        if (!copyResponseCurrent(epoch, token)) return;
        if (applyCopyPayload(data)) render();
        scheduleCopyPoll();
      }).catch(function () {
        if (!copyResponseCurrent(epoch, token)) return;
        scheduleCopyPoll();
      });
    }

    function startCopyPoll() {
      copyAttempts = 0;
      copyStartedAt = Date.now();
      stopCopyPoll();
      clearCopyDeadline();
      copyDeadlineTimer = setTimeout(function () {
        if (!copyPollActive()) return;
        failCopyWait();
      }, COPY_POLL_DEADLINE_MS);
      pollCopyOnce();
    }

    function copyWaiting() {
      return state.copyStatus === 'pending' || state.copyStatus === 'generating';
    }

    function cannedParagraph(top) {
      return (global.COMBO_WHY && global.COMBO_WHY[top.id]) || top.why;
    }

    function recommendationParagraph(top) {
      if (state.copy && state.copy.paragraph) return state.copy.paragraph;
      if (copyWaiting()) return '';
      return cannedParagraph(top);
    }

    function renderResult() {
      if (state.loadingResult) return '<div class="fit-quiz__loading paragraph">Loading your results…</div>';
      var match = computeMatch(state.answers);
      var top = match && match.primary;
      if (!top) return '<p class="paragraph">Hmm, no match found. Try adjusting your answers.</p>';
      if (!state.submitted && !state.submissionToken) submitResultIfNeeded(top);

      var sz = sizing();
      var paragraphText = recommendationParagraph(top);
      var img = global.LINER_IMG && global.LINER_IMG[top.id];
      var variantMatch = bridge().resolveVariantMatch ? bridge().resolveVariantMatch(top.id, sz.linerSize) : null;
      var hasCatalog = bridge().hasLinerCatalog ? bridge().hasLinerCatalog(top.id) : false;
      var canCart = !!(variantMatch && variantMatch.available && variantMatch.id && bridge().addRecommendedToCart);
      var showNotify = !!(variantMatch && !variantMatch.available && variantMatch.id && bridge().openBackInStockNotify);
      var mondoLabel = bridge().mondoOptionName ? bridge().mondoOptionName() : 'Size (Mondo Point)';

      var footProfile = [
        { l: 'Forefoot', v: global.LABELS && global.LABELS.ff && global.LABELS.ff[state.answers.ff] },
        { l: 'Instep', v: global.LABELS && global.LABELS.ins && global.LABELS.ins[state.answers.ins] },
        { l: 'Ankle', v: global.LABELS && global.LABELS.ank && global.LABELS.ank[state.answers.ank] },
        { l: 'Calf', v: global.LABELS && global.LABELS.cal && global.LABELS.cal[state.answers.cal] },
      ].filter(function (r) { return r.v; });

      var lead = state.answers.lead || {};
      var html = '<div class="fit-quiz__result"><div class="fit-quiz__result-hero"><p class="fit-quiz__eyebrow">✓ Our best match</p>' +
        '<h1 class="h1 fit-quiz__result-name">The ' + esc(top.name) + '.</h1><p class="paragraph fit-quiz__result-tagline">' + esc(top.tag) + '</p>' +
        '<div class="fit-quiz__result-photo-wrap"><div class="fit-quiz__result-watermark" aria-hidden="true">' + esc(top.name) + '</div>' +
        (sz.linerSize != null ? '<span class="fit-quiz__result-size-badge">Suggested size · Mondo ' + sz.linerSize.toFixed(1) + '</span>' : '') +
        (img ? '<img class="fit-quiz__result-photo" src="' + esc(img) + '" alt="' + esc(top.name) + '" loading="lazy">' : '') +
        '</div></div>';

      if (lead.email || lead.phone) {
        var dest = lead.contactPref === 'text' && lead.phone ? ((lead.dialCode || '') + ' ' + lead.phone).trim() : lead.email;
        var verb = lead.contactPref === 'text' && lead.phone ? 'text' : 'email';
        html += '<div class="fit-quiz__result-thanks"><p class="fit-quiz__eyebrow">✓ Best match on its way</p><h2 class="h2 fit-quiz__result-thanks-title">Thanks' +
          (lead.name ? ', ' + esc(lead.name) : '') + '.</h2><p class="paragraph">We\'ll ' + verb + ' the <strong>' + esc(top.name) + '</strong> pairing to <strong>' + esc(dest) + '</strong>.</p></div>';
      }

      html += '<div class="fit-quiz__result-actions fit-quiz__result-actions--primary">';
      if (canCart) {
        html += '<button type="button" class="button fit-quiz__result-cta" data-action="add-cart"' + (state.addingToCart || state.submitting ? ' disabled' : '') + '>' +
          (state.addingToCart ? 'Adding…' : sz.linerSize != null ? 'Add Mondo ' + sz.linerSize.toFixed(1) + ' · ' + esc(top.name) : 'Add ' + esc(top.name) + ' to cart') + '</button>';
      }
      if (showNotify) {
        html += '<p class="fit-quiz__result-note fit-quiz__result-note--stock paragraph">Mondo ' + sz.linerSize.toFixed(1) + ' is out of stock right now.</p>' +
          '<button type="button" class="button fit-quiz__result-cta fit-quiz__result-notify-cta" data-action="notify-stock"' + (state.notifying ? ' disabled' : '') + '>' +
          (state.notifying ? 'Opening…' : 'Notify me · Mondo ' + sz.linerSize.toFixed(1)) + '</button>';
      }
      if (state.cartError) html += '<p class="fit-quiz__result-error">' + esc(state.cartError) + '</p>';
      if (!canCart && !showNotify && !state.cartError) {
        html += '<p class="fit-quiz__result-note">' + (sz.linerSize == null ? 'Complete foot length or boot size to enable add to cart.' :
          !hasCatalog ? 'Assign the ' + esc(top.name) + ' product in the Fit Quiz section settings.' :
            'No "' + esc(mondoLabel) + '" variant for Mondo ' + sz.linerSize.toFixed(1) + '.') + '</p>';
      }
      html += '</div>';

      if (footProfile.length) {
        html += section('Your foot profile', (state.answers.boot && state.answers.boot.m ? '<p class="paragraph"><strong>' + esc(state.answers.boot.b) + ' · ' + esc(state.answers.boot.m) + '</strong></p>' : '') +
          '<div class="fit-quiz__stats">' + footProfile.map(function (r) {
            return '<div class="fit-quiz__stat"><div class="fit-quiz__stat-label">' + esc(r.l) + '</div><div class="fit-quiz__stat-value">' + esc(r.v) + '</div></div>';
          }).join('') + '</div>');
      }

      var shims = global.computeShimRecommendation ? global.computeShimRecommendation(state.answers) : [];
      var shimHtml = shims.length
        ? section('Bootfitter accessories', '<p class="fit-quiz__result-note paragraph">Based on your foot profile, your bootfitter should also assess:</p>' +
          shims.map(function (s) {
            return '<div class="fit-quiz__shim"><div class="fit-quiz__shim-title">' + s.icon + ' ' + esc(s.title) + '</div><p class="paragraph">' + esc(s.summary) + '</p><p class="fit-quiz__result-note">' + esc(s.detail) + '</p></div>';
          }).join(''))
        : '';
      html += '<div class="fit-quiz__result-copy">' +
        (paragraphText
          ? '<p class="paragraph">' + esc(paragraphText) + '</p>'
          : '<p class="fit-quiz__result-note paragraph">Writing this for your boot…</p>') +
        '</div>';
      html += shimHtml;

      html += '<a class="button-secondary fit-quiz__result-browse" href="https://zipfit.com/collections/liners" target="_blank" rel="noopener noreferrer">Browse All Liners</a>' +
        '<div class="fit-quiz__result-footer"><button type="button" class="button-secondary" data-action="back">← Edit answers</button>' +
        '<button type="button" class="button-secondary" data-action="restart">↻ Retake</button></div>' +
        '<p class="fit-quiz__disclaimer">A certified ZipFit bootfitter provides the definitive fit.</p></div>';
      return html;
    }

    function section(title, body) {
      return '<div class="fit-quiz__section"><div class="fit-quiz__section-title"><span class="fit-quiz__section-dot"></span>' + esc(title) + '</div>' + body + '</div>';
    }

    function render() {
      var st = stage();
      var vis = visibleStages();
      var totalQs = vis.length;
      var stepNum = vis.indexOf(st) + 1;
      var q = quiz.getQ ? quiz.getQ(st) : (global.getQ && global.getQ(st));
      var body = '';

      if (st === 'intro') body = renderIntro();
      else if (st === 'lead') body = renderLead();
      else if (st === 'result') body = renderResult();
      else if (q) {
        body = renderProgress(q, stepNum, totalQs) + '<p class="fit-quiz__eyebrow">Question ' + stepNum + '</p>' +
          '<h2 class="h2">' + esc(q.txt) + '</h2><p class="paragraph fit-quiz__hint">' + esc(q.hint) + '</p>' +
          (q.sub ? '<div class="fit-quiz__sub">📐 ' + esc(q.sub) + '</div>' : '') +
          '<div class="fit-quiz__step-content">' + renderQuestion(q) + '</div>';
      }

      var nav = '';
      if (state.step > 0 && state.step < STAGES.length - 1) {
        nav = '<div class="fit-quiz__nav"><div class="fit-quiz__nav-left">' +
          '<button type="button" class="fit-quiz__nav-ghost" data-action="back">← Back</button>' +
          '<button type="button" class="fit-quiz__nav-ghost fit-quiz__nav-ghost--muted" data-action="restart">Start over</button></div>' +
          '<button type="button" class="button" data-action="next"' + (!canAdvance() ? ' disabled' : '') + '>' +
          (state.step === STAGES.length - 2 ? 'See my liner →' : 'Continue →') + '</button></div>';
      }

      root.innerHTML = '<div class="fit-quiz__body">' + body + '</div>' + nav;
    }
  }

  global.ZipfitFitQuizController = { mount: mount };

  var AUTO_MOUNT_MAX_TRIES = 200;

  function autoMount(tries) {
    tries = tries || 0;
    if (!quizApi().STAGES || !quizApi().STAGES.length) {
      if (tries >= AUTO_MOUNT_MAX_TRIES) {
        console.warn('fit-quiz: ZipfitLinerQuiz not loaded; quiz not mounted.');
        return;
      }
      global.setTimeout(function () { autoMount(tries + 1); }, 50);
      return;
    }
    document.querySelectorAll('[data-fit-quiz-mount]:not([data-fit-quiz-mounted])').forEach(function (el) {
      mount(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoMount);
  } else {
    autoMount();
  }
})(window);
